var feebusterService = require('../../module/PTFs/feebuster.js');
var _require = require('../../utils.js'),
  round = _require.round;
var overridePrices = function overridePrices(overrides, purchaseService) {
  var _doPriceOverride = function _doPriceOverride(ov) {
    var item = purchaseService.purchases.find(function (_) {
      return _.upc === ov.upc;
    });
    var newprice = ov.price;
    var newskuqty = item.skuqty;
    if (item.priceTaxFeeAdjustments) {
      var priceoverridePtf = item.priceTaxFeeAdjustments.find(function (a) {
        return a.name === 'priceoverride';
      });
      if (priceoverridePtf) {
        newprice = item.intCcPrice + priceoverridePtf.price;
        newskuqty = priceoverridePtf.extra.qty;
      }
    }
    var priceToSet = _feeBusterAdjust(newprice, item.dept);
    var priceoverridePriceTaxFeeAdjuster = purchaseService.priceTaxFeeAdjusters.find(function (a) {
      return a.name === 'priceoverride';
    });
    priceoverridePriceTaxFeeAdjuster.addPriceoverride(item.upc, priceToSet, newskuqty);
    _setOverride(ov.upc, ov.qty, priceToSet);
  };
  var _feeBusterAdjust = function _feeBusterAdjust(price, dept) {
    var gpiItem = purchaseService.feeBusterConfig.enabled && purchaseService.feeBusterConfig.manualinclusive && feebusterService.productPriceMustBeIncreased({
      dept: dept
    });
    var feeBusterAdjustedPrice = gpiItem ? round(price / (1 + purchaseService.feeBusterConfig.fraction)) : +price;
    if (gpiItem && feeBusterAdjustedPrice == price) {
      feeBusterAdjustedPrice--;
    }
    return Math.max(feeBusterAdjustedPrice, 1);
  };
  var _setOverride = function _setOverride(upc, qty, price) {
    purchaseService.overrides.forEach(function (ov) {
      if (ov.upc == upc) {
        ov.qty = qty;
        ov.price = price;
        return;
      }
    });
    purchaseService.overrides.push({
      upc: upc,
      qty: qty,
      price: price
    });
  };
  overrides.forEach(_doPriceOverride);
  return purchaseService;
};
module.exports = overridePrices;